module.exports = __webpack_public_path__ + "img/home5.45fbab1e.png";